module.exports = "//public.getcloudapp.com/packs/media/images/cloudapp-logo-horizontal-074be47e8a4c83d7d0ee4e5d84945372.svg";